import axios from 'axios';
import * as Copilot from './copilot';
import { notification } from 'antd';
import { getAccessToken, clearStorage } from './storage';
let isToastDisplayed = false;
const logoutUser = (message = 'Your session has expired. Please login to pick up where you left off') => {
  if (getAccessToken()) {
    if (isToastDisplayed == false) {
      notification.error({ message: message, placement: 'bottomRight' });
    }
    isToastDisplayed = true;
    setTimeout(() => {
      clearStorage();
      window.location.assign('/auth/login');
    }, 1000);
  }
};

const http = axios.create({ baseURL: import.meta.env.VITE_APP_API, withCredentials: true });

http.interceptors.request.use((config) => {
  const acccess_token = getAccessToken();
  if (acccess_token) config.headers['authorization'] = `Bearer ${acccess_token}`;
  return config;
});

http.interceptors.response.use(
  (response) => {
    return response;
  },
  async function (error) {
    const originalRequest = error.config;
    const status = error?.response?.data?.status || error?.response?.data?.statusCode || error?.response?.statusCode || error?.response?.status;
    if (status === 401 && error?.response?.data?.message?.toLowerCase()?.includes('unauthorized')) {
      logoutUser('Access denied. You do not have permission to access this portal.');
    } else {
      if (status === 401 && !originalRequest?._retry) {
        originalRequest._retry = true;
        if (originalRequest?.url?.includes('/token/refresh')) {
          logoutUser();
        }
        try {
          const access_token = await Copilot.refreshToken();
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + access_token;
          return http(originalRequest);
        } catch (err) {
          logoutUser();
        }
      }
    }
    if (error.response.status >= 500) {
      notification.error({ message: 'Service Temporarily Unavailable, Please try later', placement: 'bottomRight' });
    }
    return Promise.reject(error);
  },
);
export default http;

export const CopilotHttp = axios.create({ baseURL: import.meta.env.VITE_APP_COPILOT });

CopilotHttp.interceptors.request.use((config) => {
  const acccess_token = getAccessToken();
  if (acccess_token) config.headers['authorization'] = `Bearer ${acccess_token}`;
  return config;
});

CopilotHttp.interceptors.response.use(
  (response) => {
    return response;
  },
  async function (error) {
    const originalRequest = error.config;
    const status = error?.response?.data?.status || error?.response?.data?.statusCode || error?.response?.statusCode || error?.response?.status;
    if (status === 401 && error?.response?.data?.message?.toLowerCase()?.includes('unauthorized')) {
      logoutUser('Access denied. You do not have permission to access this portal.');
    } else {
      if (status === 401 && !originalRequest?._retry) {
        originalRequest._retry = true;
        if (originalRequest?.url?.includes('/token/refresh')) {
          logoutUser();
        }
        try {
          const access_token = await Copilot.refreshToken();
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + access_token;
          return CopilotHttp(originalRequest);
        } catch (err) {
          logoutUser();
        }
      }
    }
    if (error.response.status >= 500) {
      notification.error({ message: 'Service Temporarily Unavailable, Please try later', placement: 'bottomRight' });
    }
    return Promise.reject(error);
  },
);

export const BackOffice = axios.create({ baseURL: `${import.meta.env.VITE_APP_BACKOFFICE_API}/public` });

BackOffice.interceptors.request.use((config) => {
  const acccess_token = getAccessToken();
  if (acccess_token) config.headers['authorization'] = `Bearer ${acccess_token}`;
  return config;
});

BackOffice.interceptors.response.use(
  (response) => {
    return response?.data;
  },
  async function (error) {
    const originalRequest = error.config;
    if ((error?.response?.status === 401 || error?.response?.data?.status === 401) && !originalRequest?._retry) {
      originalRequest._retry = true;
      if (originalRequest?.url?.includes('/token/refresh')) {
        logoutUser();
      }
      try {
        const access_token = await Copilot.refreshToken();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + access_token;
        return BackOffice(originalRequest);
      } catch (err) {
        logoutUser();
      }
    }
    if (error.response.status >= 500) {
      notification.error({ message: 'Service Temporarily Unavailable, Please try later', placement: 'bottomRight' });
    }
    return Promise.reject(error);
  },
);

export const RohtasAuthHttp = axios.create({
  baseURL: `${import.meta.env.VITE_APP_AUTH_API}/public/v1`,
  withCredentials: true,
  headers: {
    'x-api-key': import.meta.env.VITE_AUTH_SDK_PUBLIC_KEY,
  },
});

RohtasAuthHttp.interceptors.request.use((config) => {
  const acccess_token = getAccessToken();
  if (acccess_token) config.headers['authorization'] = `Bearer ${acccess_token}`;
  return config;
});

RohtasAuthHttp.interceptors.response.use(
  (response) => {
    return response;
  },
  async function (error) {
    const originalRequest = error.config;
    const status = error?.response?.data?.status || error?.response?.data?.statusCode || error?.response?.statusCode || error?.response?.status;
    if (status === 401 && error?.response?.data?.message?.toLowerCase()?.includes('unauthorized')) {
      logoutUser('Access denied. You do not have permission to access this portal.');
    } else {
      if (status === 401 && !originalRequest?._retry) {
        originalRequest._retry = true;
        if (originalRequest?.url?.includes('/token/refresh')) {
          logoutUser();
        }
        try {
          const access_token = await Copilot.refreshToken();
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + access_token;
          return RohtasAuthHttp(originalRequest);
        } catch (err) {
          logoutUser();
        }
      }
    }
    if (error.response.status >= 500) {
      notification.error({ message: 'Service Temporarily Unavailable, Please try later', placement: 'bottomRight' });
    }
    return Promise.reject(error);
  },
);
